module.exports = __webpack_public_path__ + "static/media/cleandent_.d4b018d8.svg";